import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';
import { Observable } from 'rxjs';
import { ErrorHandlerUtility, EnhancedError } from '../../utilities/error-handler.utility';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private alertController: AlertController) {}

  showAlertMessage(title: string, msg: string, highPriority: boolean = false) {
    this.alertController
      .create({
        header: title,
        message: msg,
        buttons: ['OK'],
        cssClass: highPriority ? 'ss-alert high-priority-alert' : 'ss-alert',
      })
      .then((alert: HTMLIonAlertElement) => {
        alert.present();
      });
  }

  showAlertForDonation(title: string, msg: string) {
    return new Observable(observer => {
      let alertHandler: HTMLIonAlertElement;
      this.alertController
        .create({
          header: title,
          message: msg,
          buttons: [
            {
              text: 'Yes',
              role: 'yes',
            },
            {
              text: 'No',
              role: 'no',
              handler: () => {
                alertHandler.dismiss();
                return false;
              },
            },
          ],
          cssClass: 'ss-alert',
        })
        .then((alert: HTMLIonAlertElement) => {
          alertHandler = alert;
          alertHandler.present();
          observer.next(alertHandler);
          observer.complete();
        });
    });
  }

  showPasskeyAlert(title: string, msg: string): Observable<HTMLIonAlertElement> {
    return new Observable(observer => {
      this.alertController
        .create({
          header: title,
          message: msg,
          buttons: [
            {
              text: 'Yes',
              role: 'yes',
            },
            {
              text: 'No',
              role: 'no',
            },
          ],
          cssClass: 'ss-alert',
        })
        .then((alert: HTMLIonAlertElement) => {
          alert.present();
          observer.next(alert);
          observer.complete();
        });
    });
  }

  showConfirmAlert(title: string, message: string, onConfirm: () => void, confirmText: string = 'Confirm'): void {
    this.alertController
      .create({
        header: title,
        message,
        cssClass: 'ss-alert',
        buttons: [
          { text: 'Cancel', role: 'cancel' },
          { text: confirmText, role: 'destructive', handler: onConfirm },
        ],
      })
      .then((alert: HTMLIonAlertElement) => {
        alert.present();
      });
  }

  showErrorAlert(
    error: unknown, 
    defaultTitle: string = 'Error', 
    fallbackMessage?: string,
    includeSupportEmail: boolean = true,
    supportEmail: string = 'support@sunny.com'
  ): void {
    const err: EnhancedError = error as EnhancedError;
    const title: string = err.isNetworkError || ErrorHandlerUtility.isNetworkError(error) ? 'Network Error' : defaultTitle;
    let message: string;

    if (title === 'Network Error') {
      message = err.userFriendlyMessage || ErrorHandlerUtility.getUserFriendlyMessage(error);
    } else {
      message = ErrorHandlerUtility.getDisplayMessage(error, fallbackMessage);
    }
    
    if (includeSupportEmail) {
      const supportMessage: string = `. Please try again or contact us at ${supportEmail} for support.`;
      message += supportMessage;
    }
    
    this.showAlertMessage(title, message);
  }
}
